import React, {Component} from 'react';
import Status from './Status';

class Assignation extends Status
{
    
}

export default Assignation;